import _ from "lodash";
import { Store } from "../../utils/Store";
import { SessionStore } from "../../uidispatcherapi/SessionStore";
import MarketplaceClient from "../../clients/MarketplaceClient";
import MerchantInformationActions from "../../actions/MerchantInformationActions";
import * as TrackingUtil from "../../utils/TrackingUtil";
import { MerchantInformation } from "../../datatypes/merchant/MerchantInformation";

export type MerchantLoadingState = "empty" | "loading" | "loaded" | "failed";
type State = {
    merchantInformation: {
        [merchantId: string]: MerchantInformation;
    };
    status: MerchantLoadingState | null | undefined;
};
let state: State;

class MerchantInformationStoreImpl extends Store {
    constructor() {
        super();
        state = this.getEmptyState();
        this.listenTo(MerchantInformationActions.getMerchantInformation, this.getMerchantInformation);
    }

    getEmptyState(): State {
        return {
            merchantInformation: {},
            status: null
        };
    }

    getMerchantInformation(merchantId: string | null | undefined) {
        // Needs to be saved in a separate variable to ensure correct flow type checking.
        const mId = merchantId;
        if (!mId) {
            return;
        }
        const stateData = _.get(state.merchantInformation, mId);
        if (stateData) {
            return;
        }
        state.status = "loading";
        this.trigger();
        MarketplaceClient.getMerchantInformation(SessionStore.getCountry(), mId)
            .then((response: MerchantInformation) => this.onSuccess(mId, response))
            .catch(e => this.onFailed(e));
    }

    getCurrentMerchant(merchantId: string): MerchantInformation {
        return state.merchantInformation[merchantId];
    }

    onSuccess(merchantId: string, response: MerchantInformation) {
        state.merchantInformation[merchantId] = response;
        state.status = "loaded";
        this.trigger();
    }

    onFailed(error: string) {
        TrackingUtil.trackUIError("MerchantInformationStore", "Fetching of merchant failed", error);
        state.status = "failed";
        this.trigger();
    }

    getLoadingState() {
        return state.status;
    }

    // For testing
    resetState() {
        state = this.getEmptyState();
    }
}

export const MerchantInformationStore = new MerchantInformationStoreImpl();
